import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendTwoFactor } from 'services/auth'
import { useAuth } from '../../../../context/authContext'
import posthog from 'posthog-js'
import { linkMiniappAccount } from 'modules/miniapp'

interface ISendTwoFactorPayload {
    phone_number: string
    password: string
    two_factor_token: string
}
const UseSendTwoFactor = () => {
    const navigate = useNavigate()
    const { login } = useAuth()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendTwoFactorPayload) => {
            return sendTwoFactor(payload)
        },
        onSuccess: (data, variables) => {
            // Pin the PostHog identity as soon as auth succeeds (see OTP path).
            posthog.identify(variables?.phone_number, {
                phone_number: variables?.phone_number,
            })
            posthog.capture('login_completed', { method: '2fa' })
            toast.success('ورود با موفقیت انجام شد')
            login(data)
            // Same binding as the OTP path. A 2FA member is never auto-logged
            // in, but the link still saves them the SMS step next time.
            linkMiniappAccount()
            navigate('/auth/profile')
        },
        onError: () => {
            posthog.capture('two_factor_failed')
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}

export default UseSendTwoFactor
